import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import Swal from "sweetalert2";
import {
  ADD_ACTIVITY,
  getApiBaseUrl,
  CHANGE_PASSWORD,
  LOGIN,
} from "../../AssetMgt/Config/Config";

const Signin = () => {
  const navigate = useNavigate();

  const [isPasswordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };
  const route = all_routes;

  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem("isLoggedin"));
    if (user) {
      navigate(all_routes.assetmgtdashboard, { replace: true });
    }
  }, [navigate]);

  const [loginData, setLoginData] = useState({ username: "", password: "" });
  const [signInCard, setSignInCard] = useState(true);
  const [passOne, setPassOne] = useState("");
  const [passTwo, setPassTwo] = useState("");
  const [isPasswordOneVisible, setIsPasswordOneVisible] = useState(false);
  const [isPasswordTwoVisible, setIsPasswordTwoVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [resetLoading, setResetLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [performedBy, setPerformedBy] = useState("");
  const [passwordPolicy, setPasswordPolicy] = useState(null);
  // const [ws, setWs] = useState(null);
  // console.log(ws, "websocket");

  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        const res = await fetch(`${getApiBaseUrl()}/getPasswordPolicy`);
        const data = await res.json();

        if (data?.ResultData) {
          setPasswordPolicy(data.ResultData);
        } else {
          console.error("No ResultData found in response", data);
        }
      } catch (err) {
        console.error("Error fetching password policy", err);
      }
    };

    fetchPolicy();
  }, []);
  console.log(passwordPolicy, "passss");
  // const getWebSocketUrl = () => {
  //   const baseUrl = getApiBaseUrl();
  //   console.log(baseUrl, "yyyyyyyyyyyyyyyyy");

  //   try {
  //     const url = new URL(baseUrl);
  //     console.log(baseUrl, "ooooooooooooooooooooo");
  //     const wsProtocol = url.protocol === "https:" ? "wss:" : "ws:";
  //     return `${wsProtocol}//${url.host}`;
  //   } catch (err) {
  //     console.error("Invalid base URL:", baseUrl);
  //     return null;
  //   }
  // };
  const validatePassword = (pwd) => {
    if (!passwordPolicy) return "";

    const {
      MinLength,
      RequireUppercase,
      RequireLowercase,
      RequireDigit,
      RequireSpecialChar,
    } = passwordPolicy;

    if (pwd.length < MinLength) {
      return `Password must be at least ${MinLength} characters long.`;
    }
    if ((pwd.match(/[A-Z]/g) || []).length < RequireUppercase) {
      return `Password must contain at least ${RequireUppercase} uppercase letter(s).`;
    }
    if ((pwd.match(/[a-z]/g) || []).length < RequireLowercase) {
      return `Password must contain at least ${RequireLowercase} lowercase letter(s).`;
    }
    if ((pwd.match(/[0-9]/g) || []).length < RequireDigit) {
      return `Password must contain at least ${RequireDigit} digit(s).`;
    }
    if ((pwd.match(/[^A-Za-z0-9]/g) || []).length < RequireSpecialChar) {
      return `Password must contain at least ${RequireSpecialChar} special character(s) (!@#$%^&*()).`;
    }

    return "";
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");

    let loginSucceeded = false;
    let performedById = 0;
    let auditNotes = "";
    const location = "login";

    try {
      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginData),
      });

      const result = await res.json();

      if (result.status) {
        loginSucceeded = true;
        console.log(loginSucceeded);
        performedById = result.ResultData?.UserID || 0;
        auditNotes = "Login successful (Web)";

        if (result.ResultData.isTemporaryPassword) {
          setPerformedBy(result.ResultData.UserID);
          setSignInCard(false);
          setOldPassword(loginData.password);
          return;
        }

        if (localStorage.getItem("GranulesIsloggedIn")) {
          localStorage.setItem("GranulesIsloggedIn", false);
          await new Promise((resolve) => setTimeout(resolve, 3000));
        }
        localStorage.setItem("GranulesIsloggedIn", true);
        sessionStorage.setItem("user", JSON.stringify(result.ResultData));
        sessionStorage.setItem("selectedRole", result.ResultData.Role);
        sessionStorage.setItem("isLoggedin", true);
        sessionStorage.setItem(
          "GranulesRolePermissions",
          JSON.stringify(result.roleMenu),
        );
        sessionStorage.setItem(
          "UserType",
          JSON.stringify(result.ResultData.UserType),
        );
        sessionStorage.setItem(
          "ActualUserType",
          JSON.stringify(result.ResultData.UserType),
        );
        const performedOn = new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        const auditPayload = {
          ActivityType: 1,
          PerformedBy: performedById,
          PerformedOn: performedOn,
          Notes: auditNotes,
          Location: location,
          IsSucces: 1,
        };

        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(auditPayload),
        });

        navigate("/assetmgt/dashboard");
      } else {
        const auditNotes = `${result.Message} (Attempted by: ${loginData?.username})`;
        setErrorMessage(auditNotes);
      }
    } catch (error) {
      console.error("Login error:", error);
      auditNotes = "Network error during login";
      setErrorMessage("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   setErrorMessage("");

  //   let performedById = 0;
  //   let auditNotes = "";
  //   const location = "login";

  //   try {
  //     const res = await fetch(`${getApiBaseUrl()}/loginws`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(loginData),
  //     });

  //     const result = await res.json();
  //     console.log(result, "loginnn");

  //     if (result.status) {
  //       performedById = result.ResultData?.UserID || 0;
  //       auditNotes = "Login successful (Web)";

  //       // 🔑 If temporary password, redirect to password change
  //       if (result.ResultData.isTemporaryPassword) {
  //         setPerformedBy(result.ResultData.UserID);
  //         setSignInCard(false);
  //         setOldPassword(loginData.password);
  //         return;
  //       }

  //       if (localStorage.getItem("GranulesIsloggedIn")) {
  //         localStorage.setItem("GranulesIsloggedIn", false);
  //         await new Promise((resolve) => setTimeout(resolve, 3000));
  //       }
  //       localStorage.setItem("GranulesIsloggedIn", true);

  //       sessionStorage.setItem("user", JSON.stringify(result.ResultData));
  //       sessionStorage.setItem(
  //         "UserType",
  //         JSON.stringify(result.ResultData.UserType),
  //       );
  //       sessionStorage.setItem(
  //         "ActualUserType",
  //         JSON.stringify(result.ResultData.UserType),
  //       );
  //       sessionStorage.setItem("selectedRole", result.ResultData.Role);
  //       sessionStorage.setItem("isLoggedin", true);
  //       sessionStorage.setItem(
  //         "GranulesRolePermissions",
  //         JSON.stringify(result.roleMenu),
  //       );

  //       const { UserID, SessionId, Loginversion } = result.ResultData;
  //       console.log(UserID, "useriddd", result.ResultData);
  //       console.log(SessionId, "sessioniddd");
  //       console.log(Loginversion, "login_version");

  //       sessionStorage.setItem(
  //         "userSession",
  //         JSON.stringify({ UserID, SessionId, Loginversion }),
  //       );

  //       // const socket = new WebSocket("ws://192.168.1.101:8085");
  //       const wsUrl = getWebSocketUrl();
  //       if (!wsUrl) {
  //         throw new Error("WebSocket URL could not be built.");
  //       }
  //       const socket = new WebSocket(wsUrl);

  //       socket.onopen = () => {
  //         socket.send(
  //           JSON.stringify({
  //             type: "REGISTER",
  //             UserID,
  //             SessionId,
  //             Loginversion,
  //           }),
  //         );
  //         console.log("WS registered for user:", UserID);
  //       };

  //       socket.onmessage = async (event) => {
  //         const data = JSON.parse(event.data);

  //         if (data.type === "FORCE_LOGOUT") {
  //           Swal.fire({
  //             icon: "warning",
  //             title: "Logged out",
  //             text: "You have been logged out because of login from another device.",
  //           }).then(() => {
  //             sessionStorage.clear();
  //             localStorage.removeItem("GranulesIsloggedIn");
  //             window.location.href = "/Account/Login";
  //           });
  //         }

  //         if (data.type === "LOGOUT_CONFIRMATION") {
  //           const result = await Swal.fire({
  //             title: "Already Logged In",
  //             text: data.message,
  //             icon: "warning",
  //             showCancelButton: true,
  //             confirmButtonText: "Yes, logout other session",
  //             cancelButtonText: "Cancel",
  //             allowOutsideClick: false,
  //           });

  //           if (result.isConfirmed) {
  //             socket.send(
  //               JSON.stringify({
  //                 type: "CONFIRM_LOGOUT",
  //                 UserID,
  //                 confirm: true,
  //               }),
  //             );

  //             sessionStorage.setItem(
  //               "userSession",
  //               JSON.stringify({ UserID, SessionId, Loginversion }),
  //             );
  //             console.log("User confirmed logout of other session.");
  //             navigate("/assetmgt/dashboard");
  //           } else {
  //             socket.send(
  //               JSON.stringify({
  //                 type: "CONFIRM_LOGOUT",
  //                 UserID,
  //                 confirm: false,
  //               }),
  //             );
  //             socket.close();

  //             Swal.fire({
  //               icon: "info",
  //               title: "Login Cancelled",
  //               text: "You remain logged in on your first device.",
  //             });
  //           }
  //         }

  //         if (data.type === "CANCELLED_LOGOUT") {
  //           socket.close();
  //         }

  //         if (data.type === "REGISTERED_SUCCESS") {
  //           navigate("/assetmgt/dashboard");
  //         }
  //       };

  //       setWs(socket);

  //       const performedOn = new Date()
  //         .toISOString()
  //         .slice(0, 19)
  //         .replace("T", " ");
  //       const auditPayload = {
  //         ActivityType: 1,
  //         PerformedBy: performedById,
  //         PerformedOn: performedOn,
  //         Notes: auditNotes,
  //         Location: location,
  //         IsSucces: 1,
  //       };

  //       await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(auditPayload),
  //       });
  //     } else {
  //       const auditNotes = `${result.Message} (Attempted by: ${loginData?.username})`;
  //       setErrorMessage(auditNotes);
  //     }
  //   } catch (error) {
  //     console.error("Login error:", error);
  //     auditNotes = "Network error during login";
  //     setErrorMessage("Something went wrong.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handlePassOneChange = (e) => {
    const value = e.target.value;

    setPassOne(value);

    setNewPasswordError(validatePassword(value));
    if (passTwo && e.target.value !== passTwo) {
      setConfirmPasswordError("Passwords do not match.");
    } else {
      setConfirmPasswordError("");
    }
  };

  const handlePassTwoChange = (e) => {
    const value = e.target.value;
    setPassTwo(value);
    if (passOne && e.target.value !== passOne) {
      setConfirmPasswordError("Passwords do not match.");
    } else {
      setConfirmPasswordError("");
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setResetLoading(true);
    const performedOn = new Date().toISOString().slice(0, 19).replace("T", " ");
    let isSuccess = 0;
    let activityNotes = "Password change attempted";

    try {
      const response = await fetch(`${getApiBaseUrl()}${CHANGE_PASSWORD}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: loginData?.username,
          new_password: passOne,
          old_password: oldPassword,
          PerformedBy: String(performedBy),
        }),
      });

      const data = await response.json();

      if (data.status === true) {
        isSuccess = 1;
        activityNotes = "Password changed successfully";

        const activityPayload = {
          ActivityType: 4,
          PerformedBy: performedBy,
          PerformedOn: performedOn,
          Notes: activityNotes,
          Location: "changepassword",
          IsSucces: isSuccess,
        };

        try {
          await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(activityPayload),
          });
        } catch (activityError) {
          console.error("Error calling /addActivity:", activityError);
        }

        setResetLoading(false);

        await Swal.fire({
          icon: "success",
          title: "Password Changed",
          text: "Please login again.",
          confirmButtonText: "OK",
          showConfirmButton: true,
        });

        window.location.reload();
      } else {
        isSuccess = 0;
        activityNotes = "Password change failed";

        await logChangePasswordActivity(
          performedBy,
          performedOn,
          activityNotes,
          isSuccess,
        );
        setResetLoading(false);

        Swal.fire("Error", activityNotes, "error");
      }
    } catch (error) {
      console.error("Change password error:", error);
      isSuccess = 0;
      activityNotes = "Error connecting to server";

      await logChangePasswordActivity(
        performedBy,
        performedOn,
        activityNotes,
        isSuccess,
      );
      setResetLoading(false);

      Swal.fire("Error", "Something went wrong. Please try again.", "error");
    }
  };

  const logChangePasswordActivity = async (
    performedBy,
    performedOn,
    notes,
    isSuccess,
  ) => {
    try {
      const payload = {
        ActivityType: 4,
        PerformedBy: performedBy,
        PerformedOn: performedOn,
        Notes: notes,
        Location: "changepassword",
        IsSucces: isSuccess,
      };

      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
    } catch (err) {
      console.error("Error logging change password activity:", err);
    }
  };

  const isButtonDisabled =
    resetLoading ||
    newPasswordError !== "" ||
    confirmPasswordError !== "" ||
    !passOne ||
    !passTwo;

  return (
    <>
      {signInCard ? (
        <div className="main-wrapper">
          <div className="account-content">
            <div className="login-wrapper">
              <div className=" d-flex justify-content-center align-items-center w-100 row">
                <div className="card col-12 col-md-8 col-lg-4">
                  <div className="card-body pb-0">
                    <form onSubmit={handleLogin}>
                      <div className="login-userset">
                        <div className="login-logo logo-normal">
                          <ImageWithBasePath
                            src="assets/img/logo.png"
                            alt="img"
                          />
                        </div>

                        <Link
                          to={route.dashboard}
                          className="login-logo logo-white"
                        >
                          <ImageWithBasePath
                            src="assets/img/logo-white.png"
                            alt="Img"
                          />
                        </Link>
                        <div className="login-userheading d-flex justify-content-center">
                          <h3>Sign In</h3>
                        </div>
                        <div className="mb-3 w-lg-75 m-auto">
                          <label className="form-label">
                            User ID <span className="text-danger"> *</span>
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              name="username"
                              className="form-control border-end-0"
                              value={loginData.username}
                              // onChange={handleChange}
                              onChange={(e) => {
                                handleChange({
                                  target: {
                                    name: "username",
                                    value: e.target.value,
                                  },
                                });
                              }}
                              disabled={loading}
                              required
                              onWheel={(e) => e.target.blur()}
                              placeholder="Enter Username"
                            />
                            <span className="input-group-text border-start-0">
                              <i className="ti ti-user" />
                            </span>
                          </div>
                        </div>
                        <div className="mb-3 w-lg-75 m-auto">
                          <label className="form-label">
                            Password <span className="text-danger"> *</span>
                          </label>
                          <div className="pass-group">
                            <input
                              type={isPasswordVisible ? "text" : "password"}
                              name="password"
                              className="pass-input form-control"
                              value={loginData.password}
                              onChange={handleChange}
                              disabled={loading}
                              required
                              onCopy={(e) => e.preventDefault()}
                              onPaste={(e) => e.preventDefault()}
                              onCut={(e) => e.preventDefault()}
                              placeholder="Enter Password"
                            />
                            <span
                              className={`ti toggle-password ${
                                isPasswordVisible ? "ti-eye" : "ti-eye-off"
                              }`}
                              onClick={togglePasswordVisibility}
                            ></span>
                          </div>
                        </div>

                        <div className="form-login authentication-check">
                          <div className="row">
                            <div className="">
                              <div className="text-end">
                                <Link
                                  className="text-orange fs-16 fw-medium"
                                  to={route.forgotPassword}
                                >
                                  Forgot Password?
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="form-login d-flex justify-content-center">
                          <button
                            type="submit"
                            className="btn text-white w-50"
                            style={{
                              backgroundColor: "#0984E3",
                              borderColor: "#0984E3",
                            }}
                            // onClick={handleLogin}
                            disabled={loading}
                          >
                            {loading ? "Logging in..." : "Login"}
                          </button>
                        </div>
                        {errorMessage && (
                          <div className="alert alert-danger py-1 mb-3">
                            {errorMessage}
                          </div>
                        )}
                      </div>
                    </form>
                  </div>
                  <div className="card-footer border-0 d-flex justify-content-center pb-0">
                    Filter Management System v.1.1.0
                  </div>
                  <div className="card-footer border-0 d-flex justify-content-center pt-1">
                    Controlytics AI Private Limited
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="main-wrapper">
          <div className="account-content">
            <div className="login-wrapper">
              <div className=" d-flex justify-content-center align-items-center w-100 row">
                <div className="card col-12 col-md-8 col-lg-4">
                  <div className="card-body pb-0">
                    <form onSubmit={handleChangePassword}>
                      <div className="login-userset">
                        <div className="login-logo logo-normal">
                          <ImageWithBasePath
                            src="assets/img/logo.png"
                            alt="img"
                          />
                        </div>

                        <Link
                          to={route.dashboard}
                          className="login-logo logo-white"
                        >
                          <ImageWithBasePath
                            src="assets/img/logo-white.png"
                            alt="Img"
                          />
                        </Link>
                        <div className="login-userheading d-flex justify-content-center">
                          <h3>Reset Password</h3>
                        </div>
                        <div className="mb-3 w-lg-75 m-auto">
                          <label className="form-label">
                            User ID <span className="text-danger">*</span>
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              name="oldPassword"
                              className="pass-input form-control"
                              value={loginData?.username}
                              disabled
                            />
                            <span className="input-group-text border-start-0">
                              <i className="ti ti-user" />
                            </span>
                          </div>
                        </div>

                        <div className="mb-3 w-lg-75 m-auto">
                          <label className="form-label">
                            Password <span className="text-danger">*</span>
                          </label>
                          <div className="pass-group">
                            <input
                              type={isPasswordOneVisible ? "text" : "password"}
                              name="passOne"
                              className="pass-input form-control"
                              value={passOne}
                              onChange={handlePassOneChange}
                              disabled={resetLoading}
                              required
                              onCopy={(e) => e.preventDefault()}
                              onPaste={(e) => e.preventDefault()}
                              onCut={(e) => e.preventDefault()}
                            />
                            <span
                              className={`ti toggle-password ${
                                isPasswordOneVisible ? "ti-eye" : "ti-eye-off"
                              }`}
                              onClick={() =>
                                setIsPasswordOneVisible((prev) => !prev)
                              }
                            ></span>
                          </div>
                          {newPasswordError && (
                            <div className="text-danger mt-1">
                              {newPasswordError}
                            </div>
                          )}
                        </div>

                        <div className="mb-3 w-lg-75 m-auto">
                          <label className="form-label">
                            Confirm Password{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="pass-group">
                            <input
                              type={isPasswordTwoVisible ? "text" : "password"}
                              name="passTwo"
                              className="pass-input form-control"
                              value={passTwo}
                              onChange={handlePassTwoChange}
                              disabled={resetLoading}
                              required
                              onCopy={(e) => e.preventDefault()}
                              onPaste={(e) => e.preventDefault()}
                              onCut={(e) => e.preventDefault()}
                            />
                            <span
                              className={`ti toggle-password ${
                                isPasswordTwoVisible ? "ti-eye" : "ti-eye-off"
                              }`}
                              onClick={() =>
                                setIsPasswordTwoVisible((prev) => !prev)
                              }
                            ></span>
                          </div>
                        </div>

                        {confirmPasswordError && (
                          <div className="text-danger mt-1">
                            {confirmPasswordError}
                          </div>
                        )}

                        <div className="form-login d-flex justify-content-center">
                          <button
                            type="submit"
                            className="btn text-white w-50"
                            style={{
                              backgroundColor: "#0984E3",
                              borderColor: "#0984E3",
                            }}
                            disabled={isButtonDisabled}
                          >
                            {resetLoading ? "Resetting..." : "Reset Password"}
                          </button>
                        </div>
                        {errorMessage && (
                          <div className="alert alert-danger py-1 mb-3">
                            {errorMessage}
                          </div>
                        )}
                      </div>
                    </form>
                  </div>
                  <div className="card-footer border-0 d-flex justify-content-center">
                    Filter Management System v.1.1.0
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Signin;
